import { useMemo } from 'react'

import { Scope } from '../../../../../../../../../enums/scope'
import { useScopedFeatureAccess } from '../../../../../../../../../hooks/useScopedFeatureAccess'

interface AutomaticPaymentRemindersAccess {
  isAutomaticPaymentRemindersLockedByUpsell: boolean
  shouldDisplayAutomaticPaymentReminders: boolean
}

export const useAutomaticPaymentRemindersAccess = (): AutomaticPaymentRemindersAccess => {
  const { isLockedByUpsell, shouldShowFeature } = useScopedFeatureAccess(
    Scope.InvoiceReminderAutomatic,
    Scope.InvoiceReminderAutomaticUpsell,
  )

  return useMemo(
    () => ({
      isAutomaticPaymentRemindersLockedByUpsell: isLockedByUpsell,
      shouldDisplayAutomaticPaymentReminders: shouldShowFeature,
    }),
    [isLockedByUpsell, shouldShowFeature],
  )
}
